import { motion } from "framer-motion";
import { LogoMark } from "./Logo";
import { CONTACT_EMAIL } from "@/lib/content";

const LINES = ["You are worthy.", "You are deserving.", "You are the gift."];

export const Footer = () => (
  <footer className="bg-[#2D2A26] text-[#FBFBF8] pt-24 pb-10 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="font-display font-light leading-[0.95] text-[clamp(2.6rem,7vw,6.5rem)]">
        {LINES.map((l, i) => (
          <span key={l} className="block overflow-hidden">
            <motion.span className="block" initial={{ y: "100%" }} whileInView={{ y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 1.1, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}>{l}</motion.span>
          </span>
        ))}
        <span className="block italic text-[#E3A57F]">You are Shaya.</span>
      </div>
      <div className="mt-20 pt-8 border-t border-white/15 flex flex-col sm:flex-row gap-6 sm:items-center justify-between text-sm text-[#CFC8BC]">
        <div className="flex items-center gap-3 text-[#FBFBF8]"><LogoMark className="w-7 h-7" /><span className="tracking-[0.2em]">SHAYA SPIRITUAL PRACTICE</span></div>
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link" className="link-underline w-fit">{CONTACT_EMAIL}</a>
        <div className="flex items-center gap-6">
          <span>© {new Date().getFullYear()}</span>
          <a href="/admin" data-testid="nav-admin-login-button" className="link-underline">Admin</a>
        </div>
      </div>
    </div>
  </footer>
);
